module.exports = __webpack_public_path__ + "img/img30.1d45c602.svg";